import { render } from "./ProduitPartenariat.vue?vue&type=template&id=badc6898&scoped=true&ts=true"
import script from "./ProduitPartenariat.vue?vue&type=script&lang=ts"
export * from "./ProduitPartenariat.vue?vue&type=script&lang=ts"

import "./ProduitPartenariat.vue?vue&type=style&index=0&id=badc6898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badc6898"]])

export default __exports__